function version() {
    return "release 1.1";
  }
  
  export default version;
  